module.exports = __webpack_public_path__ + "assets/img/icon-end-bid.fc6040a3.png";